import List from "@/components/list";
import router from "@/router";
import vue from "@/main";
import { tableBaseProps } from '@/utils/common.js';
import './convene.scss';

const Table = (args) => {
  const { listeners, props } = args;
  const RCSelectionChange = listeners["selection-change"] || function () { };
  const { groupSourceType = 1, isOnline = 1, isParty = 0, isSamllClass = 0, classId = "", trainTypeName = "" } = props

  function arraySpanMethod({ row, column, rowIndex, columnIndex }) {
    let startIndex = groupSourceType === 1 ? 4 : 5
    if (columnIndex === startIndex) {
      return [1, 3]
    } else if (columnIndex === startIndex + 1 || columnIndex === startIndex + 2) {
      return [0, 0]
    }
  }

  function goDetail(enroll) {
    router.push({
      path: "/offlineClass/editClassGroup",
      query: { classId, id: enroll.uuid, onlyLook: true, isSamllClass, trainTypeName },
    });
  }
  const ClassName = ({ props: { vo } }) => {
    const offlineClass = vo.row;
    return (
      <div class="base-hover-char groupName_style" onClick={() => goDetail(offlineClass)}>
        {offlineClass.groupName}
      </div>
    );
  };

  const Liaison = ({ props: { vo } }) => {
    const offlineClass = vo.row;
    const { liaisonList } = offlineClass
    return (
      <div>
        {liaisonList.map(item =>
          <div class="flex_container">
            <div class="width-left">{item.userName}</div>
            <div class="width-middle">{item.unitPosition}</div>
            <el-tooltip class="item" effect="dark" content={item.roomNumber} placement="top">
              <div class="roomNumber_style">{item.roomNumber}</div>
            </el-tooltip>
          </div>
        )}
      </div>
    )
  }

  function deleteGroup(enroll) {
    vue.$emit("deleteGroup", enroll);
  }

  function updateGroup(enroll) {
    router.push({
      path: "/offlineClass/editClassGroup",
      query: { classId: args.props.classId, id: enroll.uuid, isOnline, isSamllClass, trainTypeName },
    });
  }

  const Deal = ({ props: { vo } }) => {
    const enroll = vo.row;
    const dealConf = [
      ["icon-edit", "编辑", () => updateGroup(enroll), "group:update"],
      ["icon-delete-group", "解散", () => deleteGroup(enroll), "group:delete"],
    ];
    return (
      <div class="deal-group">
        {dealConf.map((item) => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const AccountTableConfig = [
    {
      ...tableBaseProps("班组名称", "groupName", "200"),
      render: (vo) => <ClassName vo={vo} />,
    },
    tableBaseProps("召集人", "leaderUserNames", "m120"),
    tableBaseProps("成员数量", "memberCount", "90"),
    {
      ...tableBaseProps("联络员", "convener", "120"),
      showOverflowTooltip: false,
      render: (vo) => <Liaison vo={vo} />
    },
    tableBaseProps("联络员单位及职务", "", "220"),
    tableBaseProps("联络员房间号", "", "150"),
    // tableBaseProps("自习室", "studyRoom", "m120"),
  ]

  if (groupSourceType === 1) {
    AccountTableConfig.unshift(
      {
        type: "selection",
        label: "main"
      }
    )
  }

  AccountTableConfig.push(
    {
      label: "操作",
      fixed: "right",
      width: "80",
      render: (vo) => <Deal vo={vo} />,
    }
  )
  return (
    <List
      {...args}
      empty-text={(isParty === 0 || groupSourceType == 1) ? "尚未添加任何班组，点击左上角【添加】可进行班组添加" : "分组信息由党校同步，无法自行添加"}
      onSelectionChange={RCSelectionChange}
      span-method={arraySpanMethod}
      talbeCols={AccountTableConfig}
    />
  );
}

export default Table;
